// @ts-nocheck
import { Plugin } from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','dva','getInitialState','initialStateConfig','locale','qiankun',],
});

export { plugin };
